import PropTypes from "prop-types";
import React from "react";
import { createUseStyles } from "react-jss";
import { useGlobalContext } from "../Context";
var useStyles = createUseStyles(function (theme) { return ({
    root: {
        fontSize: 16,
        backgroundColor: theme.colors.white,
        width: "100%",
        maxWidth: theme.maxWidth,
        color: theme.colors.black,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        overflow: "hidden",
        padding: "30px 40px",
        textAlign: "center",
        lineHeight: "150%",
        margin: "0 auto",
    },
}); });
var Disclaimer = function (_a) {
    var disclaimerText = _a.disclaimerText, vendorDisclaimers = _a.vendorDisclaimers;
    var classes = useStyles();
    var vendor = useGlobalContext().vendor;
    if (vendorDisclaimers) {
        return (React.createElement("div", { className: classes.root },
            React.createElement("p", null, vendorDisclaimers[vendor].toString())));
    }
    return (React.createElement("div", { className: classes.root },
        React.createElement("p", null, disclaimerText === null || disclaimerText === void 0 ? void 0 : disclaimerText.toString())));
};
Disclaimer.propTypes = {
    disclaimerText: PropTypes.string,
    vendorDisclaimers: PropTypes.shape({
        asurion: PropTypes.string.isRequired,
        att: PropTypes.string.isRequired,
        cricket: PropTypes.string.isRequired,
        sprint: PropTypes.string.isRequired,
        staples: PropTypes.string.isRequired,
        verizon: PropTypes.string.isRequired,
    }),
};
export default Disclaimer;
